import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';

import {HttpClient} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {ConfigService} from './config.service';
import {EventsEmitterService} from './emitter.service';
import {LogService} from './log.service';
import {SecurityService} from './security.service';

@Injectable()
export class VisualsService extends SecurityService {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService,
  ) {
    super(http, configService, eventsEmitterService, router, logger);
  }

  /**
   * Parse object(JSON) to standard HTTP:GET param format
   *
   * @param params { 0-n?:any }
   */
  protected urlParamsToString(params: any) {
    let urlParams = '';
    Object.keys(params).forEach((param, index) => {
      urlParams += param + '=' + params[param] + '&';
    });

    return urlParams + 'langId=' + localStorage.getItem('langId');
  }

  /**
   * Get list of form fields / filters
   *
   * @param params { group:string, ...0-n?:any }
   */
  getFormFieldDefinition(name: string, params: any): Observable<any> {
    let serviceUrl =
      this.baseUrl + name + '/formFieldDefinitions?' + this.urlParamsToString(params);

    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  setLangId(langId: number) {
    let serviceUrl = this.baseUrl + 'VisualService/setLang?' + 'langId=' + langId;
    this.request(serviceUrl).subscribe((lang) => {});
  }

  getVisuals(group: string, langId: string): Observable<any> {
    let serviceUrl =
      this.baseUrl + 'VisualService/getVisuals?' + 'group=' + group + '&langId=' + langId;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  getAllVisuals(langId: string): Observable<any> {
    let serviceUrl = this.baseUrl + 'VisualService/getAllVisuals?' + 'langId=' + langId;
    return this.request(serviceUrl).pipe(
      map((response) => {
        let body = response;
        localStorage.setItem('visualsArray_' + langId, JSON.stringify(body));
        return body;
      }),
      catchError(super.handleError),
    );
  }

  getCurrencies(langId: string): Observable<any> {
    let serviceUrl = this.baseUrl + 'UtilService/getCurrencies';

    return this.request(serviceUrl).pipe(
      map((response) => {
        let body = response;
        localStorage.setItem('currencies_' + langId, JSON.stringify(body));
        return body;
      }),
      catchError(super.handleError),
    );
  }

  getLookup(table: string, column: string, langId: string): Observable<any> {
    let serviceUrl =
      this.baseUrl +
      'UtilService/getLookup?' +
      'param1=' +
      table +
      '&param2=' +
      column +
      '&param3=' +
      langId;
    return this.request(serviceUrl).pipe(
      map((response) => {
        let body = response;
        this.setStorageLkp(table, column, langId, body);
        localStorage.setItem('LKP_' + table + '_' + column + '_' + langId, JSON.stringify(body));
        return body;
      }),
      catchError(super.handleError),
    );
  }

  getAllLookups(langId: string): Observable<any> {
    let serviceUrl = this.baseUrl + 'UtilService/getAllLookups?' + 'langId=' + langId;
    return this.request(serviceUrl).pipe(
      map((response) => {
        let body = response;

        let lkpCellRender = JSON.parse(localStorage.getItem('lkpCellRender' + langId));

        let currentGroup = [];
        body.forEach((lkp) => {
          lkpCellRender[lkp.lkupTable] = lkpCellRender[lkp.lkupTable]
            ? lkpCellRender[lkp.lkupTable]
            : {};
          lkpCellRender[lkp.lkupTable][lkp.lkupCol] = lkpCellRender[lkp.lkupTable][lkp.lkupCol]
            ? lkpCellRender[lkp.lkupTable][lkp.lkupCol]
            : {};
          lkpCellRender[lkp.lkupTable][lkp.lkupCol][lkp.val] = lkp.valLabel;

          currentGroup = localStorage.getItem(
            'LKP_' + lkp.lkupTable + '_' + lkp.lkupCol + '_' + langId,
          )
            ? JSON.parse(
                localStorage.getItem('LKP_' + lkp.lkupTable + '_' + lkp.lkupCol + '_' + langId),
              )
            : [];
          if (currentGroup.findIndex((x) => x.id === lkp.val) === -1) {
            currentGroup.push({id: lkp.val, text: lkp.valLabel});
          }
          localStorage.setItem(
            'LKP_' + lkp.lkupTable + '_' + lkp.lkupCol + '_' + langId,
            JSON.stringify(currentGroup),
          );
        });

        localStorage.setItem('lkpCellRender' + langId, JSON.stringify(lkpCellRender));

        return body;
      }),
      catchError(super.handleError),
    );
  }

  getPaymentTypes(langId: string): Observable<any> {
    let serviceUrl = this.baseUrl + 'VisualService/getPaymentTypes?' + 'langId=' + langId;
    return this.request(serviceUrl).pipe(
      map((response) => {
        let body = response;
        localStorage.setItem('paymenttypes_' + langId, JSON.stringify(body));
        return body;
      }),
      catchError(super.handleError),
    );
  }

  getDisapprCodes(langId: string): Observable<any> {
    let serviceUrl = this.baseUrl + 'VisualService/getDisapprCodes?' + 'langId=' + langId;
    return this.request(serviceUrl).pipe(
      map((response) => {
        let body = response;
        localStorage.setItem('disapprcodes_' + langId, JSON.stringify(body));
        return body;
      }),
      catchError(super.handleError),
    );
  }

  getParam(key: string): Observable<any> {
    let serviceUrl = this.baseUrl + 'UtilService/getParamValueByKey?' + 'key=' + key;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  public getLabelLookUpList(element, array: Array<JSON>): any {
    let pos = 0;

    array.forEach((item, index) => {
      if (item['id'] == element) pos = index;
    });

    return array[pos];
  }

  setStorageLkp(table: string, column: string, langId: string, array: any) {
    let lkpCellRender = JSON.parse(localStorage.getItem('lkpCellRender' + langId));

    array.forEach((json) => {
      lkpCellRender[table] = lkpCellRender[table] ? lkpCellRender[table] : {};
      lkpCellRender[table][column] = lkpCellRender[table][column]
        ? lkpCellRender[table][column]
        : {};
      lkpCellRender[table][column][json.id] = json.text;
    });

    localStorage.setItem('lkpCellRender' + langId, JSON.stringify(lkpCellRender));
  }

  removeStorageLkp(table: string, column: string, langId: string, array: any) {
    let lkpCellRender = JSON.parse(localStorage.getItem('lkpCellRender' + langId));

    array.forEach((json) => {
      lkpCellRender[table] = lkpCellRender[table] ? lkpCellRender[table] : {};
      lkpCellRender[table][column] = lkpCellRender[table][column]
        ? lkpCellRender[table][column]
        : {};
      delete lkpCellRender[table][column][json.id];
    });

    localStorage.setItem('lkpCellRender' + langId, JSON.stringify(lkpCellRender));
  }
}
